import { lazy } from 'react';

export const DetailsApplicationLazy = lazy(
  () => import('./DetailsApplication')
);
